import commonMixin from '../../mixins/_common';
import modalMixin from '../../mixins/_modal';
import flashMessageMixin from '../../mixins/_flash_messages';

/**
 *  反映前確認コンポーネント
 */
export default {
    name: 'modalDeployConfirm_',
    template: '#modal_deploy_confirm_template',
    data() {
        return {
            // 編集中のページキー
            edit_page_key: null,
            // 編集中のタイトル
            edit_name: null,
        };
    },
    props: {
        // ページキー
        page_key: {
            type: String,
            default: '',
        },
        // タイトル
        name: {
            type: String,
            default: '',
        },
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin,
    ],
    emits: [
        'update:page_key',
        'update:name',
        'deploy',
    ],
    methods: {
        // 編集モーダルを開く
        show: function () {
            this.edit_page_key = this.page_key;
            this.edit_name = this.name;
            this.open();
        },
        // バリデーション
        validation: function (isUniquePageKey = true, isUniqueName = true) {
            // ページキーメッセージセット
            let pageKeyMessage = '';
            if (isUniquePageKey) {
                if (this.edit_page_key && !/^[0-9a-z-]*$/.test(this.edit_page_key)) {
                    pageKeyMessage = '半角小文字英数字、ハイフン以外は入力できません';
                }
            } else {
                pageKeyMessage = 'このページIDはすでに使われています。';
            }
            this.$refs.pageKeyEditInput.setCustomValidity(pageKeyMessage);

            // タイトルメッセージセット
            let nameMessage = '';
            if (!isUniqueName) {
                nameMessage = 'このタイトルはすでに使われています。';
            }
            this.$refs.titleEditInput.setCustomValidity(nameMessage);

            // メッセージ表示
            const $form = this.$refs.form;
            if (!$form.checkValidity()) {
                $form.reportValidity();
                return false;
            }
            return true;
        },
        // ページIDが重複していないか
        isUniquePage: async function () {
            let bool = false;
            // バリデーション
            if (!this.validation()) {
                return bool;
            }
            try {
                this.$_loading();
                const response = await yahooAxios.get('/custom_page/is_unique_page', {
                    params: {
                        page_key: this.edit_page_key,
                        name: this.edit_name,
                    }
                });
                if (response.data.status === 'OK') {
                    bool = true;
                } else {
                    this.validation(response.data.data.page_key, response.data.data.name);
                }
            } catch (e) {
                await this.$root.$refs.yahooAuth.error(e);
            }
            this.$_unloading();
            return bool;
        },
        // 反映開始
        deploy: async function () {
            if (this.isAdmin || await this.isUniquePage()) {
                this.close();
                this.emit();
            }
        },

        // -------------------------
        // emit
        // -------------------------

        // 親へ通知
        emit: function () {
            this.$emit('update:page_key', this.edit_page_key);
            this.$emit('update:name', this.edit_name);
            if (!this.isAdmin) {
                this.$emit('deploy');
            }
        },
    }
};

